<template>
    <v-container fill-height="">
        <v-layout fill-height="" align-center="" justify-center="">
            <v-flex lg4 md6 sm7 xs12 >

                <div class='login-card'>

                    <div class='circle'>
                        <img class="logo" :src="logo">
                    </div>
                    <v-flex xs10 offset-xs1>

                            <form>
                                <v-flex xs10 offset-xs1 class='text-center'>
                                    <v-text-field v-model="username" prepend-icon="mdi-account" type='text' name='username' required></v-text-field>
                                </v-flex>


                                <v-flex xs10 offset-xs1 class='text-center'>
                                    <v-text-field v-model="password" prepend-icon="mdi-lock" type='password' name='password' required></v-text-field>
                                </v-flex>

                                <v-flex xs10 offset-xs1 id='login-button'>
                                    <v-btn rounded medium color="primary" block @click="loginUser()" value='login'>login</v-btn>     
                                </v-flex>
                                <div v-if="hasLoginMessage">
                                  <p class="text-center" style="padding-top:30px;">{{subtitle}}</p>
                                  <p class="text-center caption">{{current_version}}</p>
                                </div>
                                <div v-else>
                                  <p class="text-center error--text" style="padding-top:30px;">{{loginMessage}}</p>
                                  <p>  </p>
                                </div>
                            </form>
                    </v-flex>    
                </div>
            </v-flex>
        </v-layout>
    </v-container>
</template> 

<script>
import { version } from "../../package.json";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      username: "",
      password: "",
      subtitle: process.env.VUE_APP_LOGIN_SUBTITLE
    };
  },
  computed: {
    logo() {
      return require("../../public/img/logo/" + process.env.VUE_APP_LOGO);
    },
    current_version() {
      return version;
    },

    loginMessage() {
      return this.$store.state.auth.loginMessage;
    },
    hasLoginMessage() {
      if (this.$store.state.auth.loginMessage == "") {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    loginUser() {
      this.$store.dispatch("auth/login", {
        username: this.username,
        password: this.password
      });
    }
  },
  mounted() {
    clearInterval(this.$store.state.auth.expiryChecker);
    clearInterval(this.$store.state.auth.runstatistics);
  }
};
</script>


<style scoped>
#login-button {
  padding-top: 30px;
}

#login-form {
  text-align: center;
}

.circle {
  background-color: white;
  border-radius: 50%;
  position: relative;
  height: 150px;
  width: 150px;
  top: -75px;
  left: calc(50% - 75px);
  display: inline-block;
}

.login-card {
  border-radius: 20px;
  opacity: 0.9;
  background-color: white;
  display: inline-block;
  width: 100%;
  max-width: 500px;
  padding-bottom: 100px;
}

.logo {
  position: relative;
  border-radius: 0em;
  height: 100px;
  width: 100px;
  top: 25px;
  left: calc(50% - 50px);
  padding: 10px;
}
</style>
